import { render } from "./modal-bottom-notification.html?vue&type=template&id=68933f28&scoped=true&ts=true"
import script from "./modal-bottom-notification.vue?vue&type=script&lang=ts"
export * from "./modal-bottom-notification.vue?vue&type=script&lang=ts"

import "./modal-bottom-notification.scss?vue&type=style&index=0&id=68933f28&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68933f28"]])

export default __exports__